// Copyright (c) Docugami, Inc. All rights reserved.

import { backgroundGray, userConfirmedGreen } from 'components/shell/presentation/AppStyles';
import { IProgressIndicatorStyles, ProgressIndicator } from "@fluentui/react";
import React from 'react';
import { DeepPartial } from 'redux';
import styled from 'styled-components';

const ProgressContainer = styled.div<{ height: number, background: string}>`
    padding: ${props => `${props.height * .2}px ${props.height * .3}px`};
    background: ${props => props.background};
    box-sizing: border-box;
`

interface DgProgressBarProps {
    height: number;
    percentComplete?: number;
    hidden?: boolean;
    backgroundColor?: string;
}

/**
 * Styles the FluentUI progress bar
 */
export const DgProgressBar = (props: DgProgressBarProps): JSX.Element => {
    const background = props.backgroundColor ?? backgroundGray;
    const indicatorProps: DeepPartial<IProgressIndicatorStyles> = {
        itemProgress: {
            padding: 0
        },
        progressBar: {
            background: userConfirmedGreen
        },
        progressTrack: {
            background: background
        }
    };

    return (
        <ProgressContainer height={props.height} hidden={props.hidden === true} background={background}>
            <ProgressIndicator barHeight={props.height} percentComplete={props.percentComplete} styles={indicatorProps} />
        </ProgressContainer>
    )
}
